var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"listRadio"}},[_c('div',{attrs:{"id":"title"}},[_vm._t("title")],2),_c('div',{attrs:{"id":"itemList"}},[_vm._t("itemList")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }